import React, { useState } from 'react'

const CustomerForm = ({ customer_data, setCustomerData, errors }) => {

    const [phone, setPhone] = useState(customer_data?.phone || '+44-');

    const handleSetData = (e) => {
        setCustomerData(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const handleChange = (e) => {
        const value = e.target.value;

        // Ensure the phone number starts with +44 and allow only 10 digits after that
        if (value.startsWith('+44-')) {
          // Allow up to 13 characters (including +44)
          if (value.length <= 14 && /^[0-9]*$/.test(value.substring(4))) {
            setPhone(value);
            handleSetData(e);  // Call the external handleSetData function to propagate the change
          }
        } else {
          // If the country code is removed, reset it to +44
          setPhone('+44-');
        }
      };

    return (
        <div className='contact-section pt-0'>
            <div>
                <h2 className='pt-3 pb-2 fs-2 fw-semibold'>A Little bit about you</h2>
                <p>Just a few details so we can confirm your booking.</p>
            </div>

            <div className='booking-field-grid mt-5'>
                <div className='booking-field booking-field-full'>
                    <label htmlFor='fname'><i className='bi bi-person-fill'></i>Full Name</label>
                    <input
                        id='fname'
                        type="text"
                        name="fname"
                        value={customer_data?.fname || ''}
                        placeholder="Your full name"
                        onChange={handleSetData}
                    />
                    {errors?.fname && <span className='booking-field-error'>{errors?.fname}</span>}
                </div>

                <div className='booking-field'>
                    <label htmlFor='email'><i className='bi bi-envelope-fill'></i>Email Address</label>
                    <input
                        id='email'
                        type="text"
                        name="email"
                        value={customer_data?.email || ''}
                        placeholder="you@example.com"
                        onChange={handleSetData}
                    />
                    {errors?.email && <span className='booking-field-error'>{errors?.email}</span>}
                </div>

                <div className='booking-field'>
                    <label htmlFor='phone'><i className='bi bi-telephone-fill'></i>Phone Number</label>
                    <input
                        id='phone'
                        type="text"
                        name="phone"
                        value={phone}
                        onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key) || phone.length > 13) {
                                e.preventDefault();
                            }
                        }}
                        onChange={handleChange}
                        placeholder="+44-7000000000"
                    />
                    {errors?.phone && <span className='booking-field-error'>{errors?.phone}</span>}
                </div>

                <div className='booking-field booking-field-full'>
                    <label htmlFor='address'><i className='bi bi-geo-alt-fill'></i>Pickup Address</label>
                    <textarea
                        id='address'
                        rows={2}
                        className='booking-field-textarea'
                        value={customer_data?.address || ''}
                        name="address"
                        onChange={handleSetData}
                        placeholder="Where should your instructor pick you up?"
                    />
                    {errors?.address && <span className='booking-field-error'>{errors?.address}</span>}
                </div>

                <div className='booking-field'>
                    <label htmlFor='postalcode'><i className='bi bi-mailbox2'></i>Postal Code</label>
                    <input
                        id='postalcode'
                        type="text"
                        name="postalcode"
                        value={customer_data?.postalcode || ''}
                        onChange={handleSetData}
                        placeholder="e.g. LE3 5RX"
                    />
                    {errors?.postalcode && <span className='booking-field-error'>{errors?.postalcode}</span>}
                </div>
            </div>

        </div>
    )
}

export default CustomerForm
